var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3289 9.99805H13.3308C11.4902 9.99805 9.99805 11.4902 9.99805 13.3308V23.3289C9.99805 25.1695 11.4902 26.6617 13.3308 26.6617H23.3289C25.1695 26.6617 26.6617 25.1695 26.6617 23.3289V13.3308C26.6617 11.4902 25.1695 9.99805 23.3289 9.99805Z",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6541 9.99805H56.656C54.8154 9.99805 53.3232 11.4902 53.3232 13.3308V23.3289C53.3232 25.1695 54.8154 26.6617 56.656 26.6617H66.6541C68.4947 26.6617 69.9868 25.1695 69.9868 23.3289V13.3308C69.9868 11.4902 68.4947 9.99805 66.6541 9.99805Z",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3289 53.3242H13.3308C11.4902 53.3242 9.99805 54.8163 9.99805 56.6569V66.6551C9.99805 68.4957 11.4902 69.9878 13.3308 69.9878H23.3289C25.1695 69.9878 26.6617 68.4957 26.6617 66.6551V56.6569C26.6617 54.8163 25.1695 53.3242 23.3289 53.3242Z",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9868 53.3242H59.9887C58.2209 53.3242 56.5255 54.0265 55.2755 55.2765C54.0255 56.5265 53.3232 58.2219 53.3232 59.9897V69.9878",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9873 69.9863V70.0197",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9927 23.3281V33.3263C39.9927 35.0941 39.2905 36.7895 38.0404 38.0395C36.7904 39.2895 35.095 39.9917 33.3273 39.9917H23.3291",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 39.9922H10.0314",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9922 9.99805H40.0255",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9922 53.3242V53.3575",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3232 39.9922H56.656",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9873 39.9922V40.0255",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9922 69.987V66.6543",
    stroke: "#1E2939",
    strokeWidth: 6.66544,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.e4b4538afe60ea28b910272b245c8050.svg";
export { ForwardRef as ReactComponent };